/** True when a 360-analysis section has displayable content (empty `{}` / `[]` are not meaningful). */
export const hasMeaningful360Section = (value: unknown): boolean => {
  if (value == null) return false;
  if (Array.isArray(value)) return value.length > 0;
  if (typeof value !== 'object') return true;

  const record = value as Record<string, unknown>;
  const keys = Object.keys(record);
  if (keys.length === 0) return false;

  return keys.some(key => {
    const nested = record[key];
    if (nested == null) return false;
    if (Array.isArray(nested)) return nested.length > 0;
    if (typeof nested === 'object') return Object.keys(nested as object).length > 0;
    return true;
  });
};

/** Use 360 payload only when meaningful; otherwise `undefined` so components fall back to Redux. */
export const coalesce360Section = <T>(value: T | undefined | null): T | undefined =>
  hasMeaningful360Section(value) ? (value as T) : undefined;
